<template lang="pug">
el-dialog(
  :visible.sync='dialogVisible',
  title="Connect Credit Card",
  :before-close='handleClose'
)
  div.title-text {{ text }}
  div.checkbox-text
    el-checkbox(
      v-model='isDontShow'
    ) Do not show again
  div.btn-row
    el-button(type="default", @click="handleClose") Cancel
    el-button(type="primary", @click="onconformation") Confirm


</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'CreditConnectDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: 'Please connect the credit card. You will need your credit card account connected in order to use all SpendHub features.',
      isDontShow: false,
    };
  },
  methods: {
    // dontShowCreditDialog
    ...mapActions('Home', ['dontShowCreditDialog']),
    onconformation() {
      if (this.isDontShow) {
        this.$emit('handleParentComfirm');
      }
      this.$router.push('/manage-company/cc-account');
      this.$emit('handleParentClose');
    },
    handleClose() {
      this.$emit('handleParentClose');
    },
  },
};
</script>
